export default "__VITE_ASSET__CFhn_Ypo__"